import { proxy } from "valtio";
import type { BannerPreviewState } from "./bannerPreview";

/**
 * The preview the dashboard is showing, if any (MPN-2266). DashboardBanner sets it while the
 * preview is on screen and clears it on the way out; the app shell reads it to draw the
 * ADMIN PREVIEW bar above the sidebar and topbar. Null means today's shell, unchanged.
 */
export const bannerPreviewStore = proxy<{ preview: BannerPreviewState | null }>({ preview: null });
